import GMLFormat from './gml_format';
const VERSION_GML32 = 1002;

import { POINT,
	LINESTRING,
	POLYGON,
	MULTI_POINT,
	MULTI_LINESTRING,
	MULTI_POLYGON
} from '../geometry_type';


class GML32 extends GMLFormat {

	constructor() {
		super(VERSION_GML32, "http://www.opengis.net/gml/3.2", "featureMember");
		this.addGeometryType("Point", POINT);
		this.addGeometryType("Polygon", POLYGON);
		this.addGeometryType("LineString", LINESTRING);
		this.addGeometryType("MultiPoint", MULTI_POINT);
		this.addGeometryType("MultiSurface", MULTI_POLYGON);
		//addGeometryType("LineString", LINESTRING);
	}
	
}

export default GML32;